var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{ref:"lineRef",attrs:{"type":"line","height":"400","options":_vm.computedOption,"series":_vm.computedSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }